import { Box, Flex, Icon, Spacer, VStack } from '@chakra-ui/react';
import { Divider, DropzoneMultiple, Text } from '@diamond/shared/ui';
import { UploadFileOutlined } from '@mui/icons-material';
import { FieldErrorsImpl } from 'react-hook-form';

interface DocumentPOProps {
  onRemoveFile: (idx: number) => void;
  errors: Partial<FieldErrorsImpl<{ [x: string]: string }>>;
}

export function DocumentPO({ onRemoveFile, errors }: DocumentPOProps) {
  const maxUploadSize = 5;

  return (
    <Box
      flex="1"
      border="1px"
      borderColor="gray.33"
      shadow="base"
      px="4"
      py="6"
      rounded="lg"
    >
      <Flex>
        <Flex mt="1" mr="2">
          <Icon as={UploadFileOutlined} color="blue" boxSize={8} />
        </Flex>
        <VStack alignItems="flex-start" justifyContent="start">
          <Box>
            <Text as="span" fontSize="20px" fontWeight="bold">
              Document PO {''}
            </Text>
            <Text as="span" fontSize="14px" color="gray.75">
              *Opsional
            </Text>
          </Box>
          <Text fontWeight="semibold" fontSize="sm">
            Bukan untuk unggah bukti transfer
          </Text>
        </VStack>
      </Flex>
      <Divider variant="dashed" my="4" borderWidth="1px" />
      <Box rounded="lg" flex="1" p="4">
        <DropzoneMultiple
          name="purchase_order_document"
          accept={{
            'application/pdf': ['.pdf'],
            'image/*': ['.png', '.jpeg', '.jpg'],
          }}
          maxSize={5}
          onRemoveFile={onRemoveFile}
          errors={errors}
          isCentered
        />
        <Flex>
          <Spacer />
          <Text fontSize="sm" textColor="gray.75">
            {`Hanya menerima format PDF, PNG, JPG dengan ukuran maksimal ${maxUploadSize} MB`}
          </Text>
        </Flex>
      </Box>
    </Box>
  );
}
